import { createFileRoute } from '@tanstack/react-router';

import { JobCardsGridView } from '../../features/job-cards/job-cards-grid-view';

export const Route = createFileRoute('/job-cards/')({
  staticData: {
    // The grid fills to the window edge and scrolls internally, so the pager and
    // filter bar stay put while paging through 5,000+ rows.
    layout: 'full-height',
  },
  component: JobCardsIndexRoute,
});

function JobCardsIndexRoute() {
  return <JobCardsGridView />;
}
